<template>
  <div class="list-menu">
    <h4 class="title">
      {{title}}
    </h4>
    <button 
      class="close"
      v-on:click="$emit('close')"
    >
      <svgCrossClose />
    </button>
    <div class="list-wrap"> 
      <ul>
        <li 
          v-for="item, i in list"
          :key="i"
        >
          {{item}}
        </li>
      </ul> 
    </div>
    <div>
      <button class="request" 
        v-on:click="openContact"
      >
        {{buttonText}}
        <svgChevronRightInfo />
      </button>
    </div>
  </div>
</template>

<script>
import svgCrossClose from '@/svg/svgCrossClose'
import svgChevronRightInfo from '@/svg/svgChevronRightInfo'

export default {
  props: {
    list: Array,
    title: String,
    buttonText: String
  },
  methods: {
    openContact() {
      window.open('http://gynetworks.com/kr/customer/contact.php', '_blank')
    }
  },
  components: {
    svgCrossClose,
    svgChevronRightInfo
  }
}
</script>

<style lang="scss" scoped>
.list-menu {
  margin-top: 12px;
  margin-left: 12px;
  position: relative;
  width: 312px;
  background-color: white;
  padding: 16px;
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  &:before {
    position: absolute;
    top: 0;
    left: 32px;
    width: 16px;
    height: 16px;
    background-color: white;
    content: '';
    transform: translate3d(0, -50%, 0) rotate(45deg);
  }
}

h4.title {
  font-size: 12px;
  margin: 0 0 8px;
}
.list-wrap {
  height: 188px;
  overflow-x: hidden;
  overflow-y: auto;
}

ul {
  display: block;
  column-count: 2;
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);
  padding: 0 0 0 12px;
  // margin: 0;
  width: 100%;

}


ul li {
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
  &::before {
    position: absolute;
    top: 0;
    left: -10px;
    content: "·";
    display: inline-block;
    margin-right: 4px;
  }
}

button.close {
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 15px;
    height: 15px;
  }
}

button.request {
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  color: var(--info-500);
  height: 19px;
  margin-top: 18px;
  outline: 0;
  background-color: transparent;
  border: 0;
  display: inline-flex;
  align-items: center;
  svg {
    margin-left: 10px;
  }
}
</style>